import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.5 5C12.8807 5 14 3.88071 14 2.5C14 1.11929 12.8807 0 11.5 0C10.1193 0 9 1.11929 9 2.5C9 2.63472 9.01066 2.76695 9.03117 2.89589L4.29735 5.2628C3.8428 4.79275 3.20553 4.50049 2.5 4.50049C1.11929 4.50049 0 5.61978 0 7.00049C0 8.3812 1.11929 9.50049 2.5 9.50049C3.20586 9.50049 3.84339 9.20796 4.29798 8.73752L9.03117 11.1041C9.01066 11.2331 9 11.3653 9 11.5C9 12.8807 10.1193 14 11.5 14C12.8807 14 14 12.8807 14 11.5C14 10.1193 12.8807 9 11.5 9C10.7943 9 10.1569 9.29239 9.70234 9.76264L4.9689 7.39593C4.98937 7.26713 5 7.13505 5 7.00049C5 6.86561 4.98932 6.73323 4.96876 6.60415L9.70234 4.23736C10.1569 4.70761 10.7943 5 11.5 5Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }